
import React from 'react';
import { Button } from '@/components/ui/button';
import { LogIn } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';

interface AuthErrorHandlerProps {
  error: string;
  isAuthError: boolean;
  onRefresh: () => void;
}

const AuthErrorHandler: React.FC<AuthErrorHandlerProps> = ({
  error,
  isAuthError,
  onRefresh
}) => {
  const navigate = useNavigate();

  const handleSignOut = async () => {
    await supabase.auth.signOut();
    navigate('/login');
  };

  const handleSignIn = () => {
    navigate('/login');
  };

  return (
    <div className="py-6 px-4 bg-destructive/10 text-destructive rounded-md mb-4">
      <p className="font-medium text-center">{error}</p>
      
      {isAuthError ? (
        <div className="mt-4 flex flex-col items-center">
          <p className="text-sm text-center mb-3">
            Your session may have expired. Please sign out and sign in again.
          </p>
          <div className="flex gap-2">
            <Button onClick={handleSignIn} className="flex items-center gap-1">
              <LogIn size={16} />
              Sign In
            </Button>
            <Button variant="outline" onClick={handleSignOut}>
              Sign Out & Refresh
            </Button>
          </div>
        </div>
      ) : (
        <div className="mt-4 flex justify-center">
          <Button onClick={onRefresh} variant="outline">
            Try Again
          </Button>
        </div>
      )}
    </div>
  );
};

export default AuthErrorHandler;
